export default "__VITE_ASSET__D8k1lN9p__"